import { makeStyles } from '@mui/styles';

const muiStyles = makeStyles(() => ({
    gridContainer: { marginLeft: '-20px' },
    tileColumnContainer: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        padding: '0 10px',
        borderRight: '1px solid #CFCFCF',
        '&:last-child': { borderRight: 'none' },
        '&:only-child': { maxWidth: '50%' }
    },
    divider: {
        marginBottom: '5px',
        color: '#CFCFCF'
    },
    tileContainer: { height: '70px' },
    tileText: {
        minWidth: 'max-content',
        textAlign: 'left',
        fontSize: '12px',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.3px',
        color: '#757575',
        paddingLeft: '12px'
    },
    tileBalanceText: {
        fontSize: '20px',
        fontStyle: 'normal',
        lineHeight: 'normal',
        textAlign: 'left',
        color: '#000000',
        paddingLeft: '12px'
    }
}));

export default muiStyles;